var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon20BlogFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.56V2.48C5 1.66 5.66 1 6.48 1v22m8.56-22v22M13.72 7.46a2.26 2.26 0 0 1-2.25-2.26V1m4.88 6.46A2.26 2.26 0 0 0 18.6 5.2V1",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik01IDEwLjU2VjIuNDhDNSAxLjY2IDUuNjYgMSA2LjQ4IDF2MjJtOC41Ni0yMnYyMk0xMy43MiA3LjQ2YTIuMjYgMi4yNiAwIDAgMS0yLjI1LTIuMjZWMW00Ljg4IDYuNDZBMi4yNiAyLjI2IDAgMCAwIDE4LjYgNS4yVjEiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K";
export { SvgIcon20BlogFood as ReactComponent };